import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'membership_free_trials'

export const useMembershipsFreeTrialsReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Free trials',
    headerTooltipTitle: 'Free trials',
    headerTooltipDescription: 'Number of users on an active free trial.',
  })
}
